import React from 'react';

import PageTemplate from '../components/templates/PageTemplate';
import UsersView from '../components/organisms/UsersView';

const UsersContainer = () => {
  return (
    <PageTemplate>
      {/* ph-no-capture: exclude end-user PII in this view from PostHog autocapture */}
      <div className="ph-no-capture">
        <UsersView />
      </div>
    </PageTemplate>
  );
};

export default UsersContainer;
